import initialState from './initialState';
import { reducer as weeklySchedule } from './weekly_schedule_actions';
import { reducer as schedules } from './schedules_actions';

const reducers = [
	weeklySchedule,
	schedules
];

export default function reducer(state = initialState, action) {
	let newState;
	switch (action.type) {
		// Handle cross-topic actions here
		default:
			newState = state;
			break;
	}
	/* istanbul ignore next */
	return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/schedules/redux/reducer.js